/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import { AnyAction } from 'redux';

import { TService } from 'types/service';

import * as types from '../actions/ActionTypes';

type Category = null | TService['category_name'];

const initialState = null;

export default function selectedServiceCategory(
  state = initialState,
  action: AnyAction,
): Category {
  switch (action.type) {
    case types.SELECT_SERVICE_CATEGORY:
      return action.payload;
    case types.CLEAR_SERVICE_CATEGORY:
      return initialState;
    default:
      return state;
  }
}
